<div #reportContent class="payment-receipt">
  <div class="header">
    <img src="/img/Parent@2x.png" class="header-image">
    <div class="contact-info">
      <div style="font-weight:600">Royal New York</div>
      <div>661 Hadley Rd.</div>
      <div>South Plainfield, NJ 07080</div>
      <div>Phone: (908) 756-6400</div>
    </div>
    <h3>Payment Receipt</h3>
  </div>
  <hr />
  <fieldset style="width:95%">
    <legend style="font-size:16px; font-weight:bold">Payment for Order # {{Payment.OrderID}}</legend>
    <div class="receipt-information">
      <div class="customer-data">
        <div style="font-size:16px; font-weight:bold">Customer</div>
        <div>{{CustomerName || '—'}}</div>
      </div>
      <div class="receipt-data">
        <div class="data"><div>Payment Method:</div><div>{{Payment.MethodName}}</div></div>
        <div class="data"><div>Status:</div><div>{{Payment.StatusName}}</div></div>
        <div class="data"><div>Requested Date:</div><div>{{Payment.RequestedDate ? (Payment.RequestedDate | date:'MM-dd-yyyy') : '—'}}</div></div>
        <div class="data"><div>Settled/Confirmed Date:</div><div>{{SettledOrConfirmedDate ? (SettledOrConfirmedDate | date:'MM-dd-yyyy') : '—'}}</div></div>
      </div>
    </div>
  </fieldset>

  <fieldset style="width:95%">
    <legend style="font-size:14px; font-weight:bold">Amount</legend>
    <div class="data"><div>Payment Amount:</div><div>{{Payment.Amount | currency}}</div></div>
    <div class="data"><div>Fee Amount:</div><div>{{Payment.FeeAmount | currency}}</div></div>
    <div class="data"><div>Total Charged:</div><div>{{Payment.TotalAmount | currency}}</div></div>
    <div class="data"><div>Transaction Reference:</div><div>{{Payment.TransactionReference || '—'}}</div></div>
    <div class="data"><div>Masked Card/Account #:</div><div>{{Payment.MaskedReference || '—'}}</div></div>
  </fieldset>

  <fieldset style="width:95%">
    <legend style="font-size:14px; font-weight:bold">Order Balance</legend>
    <div class="data"><div>Order Total:</div><div>{{Payment.OrderTotal | currency}}</div></div>
    <div class="data"><div>Paid on This Order:</div><div>{{Payment.OrderPaid | currency}}</div></div>
    <div class="data"><div>Balance Due:</div><div>{{Payment.OrderBalanceDue | currency}}</div></div>
  </fieldset>

  <div class="footer">
    <div style="font-size:10px">
      This is a system-generated receipt retained for record-keeping purposes. Payment #{{Payment.OrderPaymentID}}.
    </div>
  </div>
</div>
